export { default } from './PeakContainerBadge';
